(function(){
'use strict';
var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
function q(s,c){return (c||document).querySelector(s)}
function qa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}

/* Warenkorb */
function sectionIds(){var ids=[];qa('[data-atm-cart-body]').forEach(function(el){var id=el.getAttribute('data-section');if(id&&ids.indexOf(id)<0){ids.push(id)}});return ids}
function setCount(n){qa('[data-atm-cart-count]').forEach(function(el){el.textContent=n;el.setAttribute('data-count',n)})}
function applySections(sections){
  if(!sections){return}
  qa('[data-atm-cart-body]').forEach(function(el){
    var html=sections[el.getAttribute('data-section')];
    if(!html){return}
    var doc=new DOMParser().parseFromString(html,'text/html');
    var fresh=doc.querySelector('[data-atm-cart-body]');
    if(fresh){el.innerHTML=fresh.innerHTML}
  });
  var c=q('[data-atm-count-src]');
  if(c){setCount(c.getAttribute('data-atm-count-src'))}
}
function refresh(){
  var ids=sectionIds();
  if(!ids.length){return Promise.resolve()}
  return fetch(root+'?sections='+ids.join(','),{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(applySections).catch(function(){})
}
function post(url,body){
  return fetch(root+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json().then(function(j){if(!r.ok){throw j}return j})})
}
var lastFocus=null;
function drawer(){return q('#atm-cart-drawer')}
function openDrawer(){
  var d=drawer();
  if(!d){window.location.href=root+'cart';return}
  lastFocus=document.activeElement;
  d.classList.add('is-open');d.setAttribute('aria-hidden','false');
  document.documentElement.classList.add('atm-lock');
  var x=q('.atm-cd__x',d);if(x){x.focus({preventScroll:true})}
}
function closeDrawer(){
  var d=drawer();
  if(!d||!d.classList.contains('is-open')){return}
  d.classList.remove('is-open');d.setAttribute('aria-hidden','true');
  document.documentElement.classList.remove('atm-lock');
  if(lastFocus&&lastFocus.focus){lastFocus.focus()}
}

/* Menue auf dem Handy */
var navFocus=null;
function nav(){return q('#atm-nav')}
function openNav(){
  var n=nav();if(!n){return}
  navFocus=document.activeElement;
  n.classList.add('is-open');n.setAttribute('aria-hidden','false');
  document.documentElement.classList.add('atm-lock','atm-nav-open');
  qa('[data-atm-nav-open]').forEach(function(b){b.setAttribute('aria-expanded','true')});
  var x=q('.atm-cd__x',n);if(x){x.focus()}
}
function closeNav(quiet){
  var n=nav();if(!n||!n.classList.contains('is-open')){return}
  n.classList.remove('is-open');n.setAttribute('aria-hidden','true');
  document.documentElement.classList.remove('atm-lock','atm-nav-open');
  qa('[data-atm-nav-open]').forEach(function(b){b.setAttribute('aria-expanded','false')});
  if(!quiet&&navFocus&&navFocus.focus){navFocus.focus()}
}

/* Produktseite */
function show(el,v){if(el){el.textContent=v||'';el.hidden=!v}}
function padLeft(tr){return parseFloat(window.getComputedStyle(tr).paddingLeft)||0}
function goSlide(sec,slide){var tr=q('[data-atm-track]',sec);if(!tr||!slide){return}tr.scrollTo({left:slide.offsetLeft-padLeft(tr),behavior:'smooth'})}
function syncThumbs(tr){
  var sec=tr.closest('[data-atm-pd]');if(!sec){return}
  var best=0,min=Infinity,pl=padLeft(tr);
  qa('[data-atm-slide]',tr).forEach(function(s,i){var dist=Math.abs(s.offsetLeft-pl-tr.scrollLeft);if(dist<min){min=dist;best=i}});
  qa('[data-atm-thumb]',sec).forEach(function(t,i){t.classList.toggle('is-on',i===best)});
}
function updatePd(sec,r){
  var d=r.dataset;
  qa('[data-atm-price]',sec).forEach(function(el){el.textContent=d.price||''});
  qa('[data-atm-compare]',sec).forEach(function(el){show(el,d.compare)});
  qa('[data-atm-save]',sec).forEach(function(el){show(el,d.save)});
  qa('[data-atm-pkg-name]',sec).forEach(function(el){el.textContent=d.name||''});
  var tpl=sec.getAttribute('data-btn')||'';
  qa('[data-atm-buy-label]',sec).forEach(function(el){el.textContent=tpl.replace('[preis]',d.price||'')});
  qa('[data-atm-buy]',sec).forEach(function(b){b.disabled=d.available==='false'});
  if(d.media){goSlide(sec,q('[data-media-id='+JSON.stringify(String(d.media))+']',sec))}
  if(sec.getAttribute('data-url')==='true'&&d.variant&&window.history&&window.history.replaceState){
    var u=new URL(window.location.href);u.searchParams.set('variant',d.variant);window.history.replaceState({},'',u.toString());
  }
}

document.addEventListener('click',function(e){
  var t=e.target;if(!t||!t.closest){return}
  var el=t.closest('[data-atm-cart-open]');
  if(el&&drawer()){e.preventDefault();refresh();openDrawer();return}
  if(t.closest('[data-atm-cart-close]')){e.preventDefault();closeDrawer();return}
  el=t.closest('[data-atm-qty]');
  if(el){
    e.preventDefault();
    var li=el.closest('[data-line]');var wrap=el.closest('[data-atm-cart-body]');
    if(!li||!wrap){return}
    wrap.classList.add('is-busy');
    post('cart/change.js',{line:parseInt(li.getAttribute('data-line'),10),quantity:parseInt(el.getAttribute('data-atm-qty'),10),sections:sectionIds().join(',')}).then(function(j){applySections(j.sections)}).catch(function(){return refresh()}).then(function(){wrap.classList.remove('is-busy')});
    return;
  }
  el=t.closest('[data-atm-upgrade]');
  if(el){
    e.preventDefault();
    var uw=el.closest('[data-atm-cart-body]');el.setAttribute('aria-busy','true');if(uw){uw.classList.add('is-busy')}
    var up={};(el.getAttribute('data-props')||'').split('||').forEach(function(x){var i=x.indexOf('::');if(i>0){up[x.slice(0,i).trim()]=x.slice(i+2).trim()}});
    var uln=parseInt(el.getAttribute('data-line')||'0',10);(uln?post('cart/change.js',{line:uln,quantity:0}):Promise.resolve()).then(function(){
      return post('cart/add.js',{items:[{id:parseInt(el.getAttribute('data-id'),10),quantity:1,properties:up}],sections:sectionIds().join(',')});
    }).then(function(j){if(j&&j.sections){applySections(j.sections)}else{return refresh()}}).catch(function(){return refresh()}).then(function(){if(uw){uw.classList.remove('is-busy')}});
    return;
  }
  el=t.closest('[data-atm-thumb]');
  if(el){
    var sec=el.closest('[data-atm-pd]');
    var i=qa('[data-atm-thumb]',sec).indexOf(el);
    goSlide(sec,qa('[data-atm-slide]',sec)[i]);
    return;
  }
  if(t.closest('[data-atm-nav-open]')){e.preventDefault();openNav();return}
  if(t.closest('[data-atm-nav-close]')){e.preventDefault();closeNav();return}
  if(t.closest('[data-atm-nav-link]')){closeNav(true);return}
  el=t.closest('[data-atm-embed]');
  if(el){
    e.preventDefault();
    var id=encodeURIComponent(el.getAttribute('data-id')||'');
    var src=el.getAttribute('data-atm-embed')==='vimeo'?'https://player.vimeo.com/video/'+id+'?autoplay=1':'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0&playsinline=1';
    var f=document.createElement('iframe');
    f.src=src;f.title='Video';f.allow='autoplay; fullscreen; picture-in-picture; encrypted-media';f.allowFullscreen=true;
    el.parentNode.replaceChild(f,el);
  }
});

document.addEventListener('submit',function(e){
  var f=e.target;
  if(!f||!f.matches||!f.matches('[data-atm-pf]')){return}
  e.preventDefault();
  var sec=f.closest('[data-atm-pd]');if(!sec){return}
  var id=new FormData(f).get('id');
  var err=q('[data-atm-err]',sec);
  if(err){err.hidden=true}
  if(!id){var dm=f.getAttribute('data-atm-demo');if(dm&&err){err.textContent=dm;err.hidden=false}return}
  var btns=qa('[data-atm-buy]',sec);
  btns.forEach(function(b){b.setAttribute('aria-busy','true')});
  var item={id:parseInt(id,10),quantity:1};
  var chosen=q('[data-atm-pkg]:checked',sec);
  var raw=chosen&&chosen.getAttribute('data-props');
  if(raw){
    var props={};var has=false;
    raw.split('||').forEach(function(x){var i=x.indexOf('::');if(i>0){props[x.slice(0,i).trim()]=x.slice(i+2).trim();has=true}});
    if(has){item.properties=props}
  }
  post('cart/add.js',{items:[item],sections:sectionIds().join(',')}).then(function(j){
    var after=sec.getAttribute('data-after');
    if(after==='checkout'){window.location.href=root+'checkout';return}
    if(after==='cart'||!drawer()){window.location.href=root+'cart';return}
    applySections(j.sections);openDrawer();
  }).catch(function(j){
    var msg=(j&&(j.description||j.message))||'Das hat nicht geklappt. Bitte versuche es noch einmal.';
    /* Entwurf in der Theme-Vorschau: Produkt ist noch nicht aktiv */
    var pick=q('[data-atm-pkg]:checked',sec);
    if(j&&(j.status===404||j.status===422)&&(!pick||pick.dataset.available!=='false')&&window.Shopify&&window.Shopify.theme&&window.Shopify.theme.role!=='main'){msg='Vorschau: Das Produkt ist noch als Entwurf angelegt. Sobald es aktiv ist, landet das Paket hier im Warenkorb.'}
    if(err){err.textContent=msg;err.hidden=false}
  }).then(function(){btns.forEach(function(b){b.removeAttribute('aria-busy')})});
});

document.addEventListener('change',function(e){
  var r=e.target;
  if(!r||!r.matches||!r.matches('[data-atm-pkg]')){return}
  var sec=r.closest('[data-atm-pd]');
  if(sec){updatePd(sec,r)}
});

document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer();closeNav()}});

function init(){
  qa('.atm-pd [data-atm-buy-main]').forEach(function(b){
    if(b.previousElementSibling&&b.previousElementSibling.classList.contains('atm-pd__stock')){return}
    var p=document.createElement('p');p.className='atm-pd__stock';p.innerHTML='<i aria-hidden="true"></i><span>Auf Lager · Lieferung in 3–5 Tagen</span>';
    b.parentNode.insertBefore(p,b);
  });
  qa('[data-atm-rotate]').forEach(function(el){
    if(el.atmOn){return}el.atmOn=true;
    var items=qa('.atm-ann__item',el);if(items.length<2){return}
    var i=0;var ms=(parseInt(el.getAttribute('data-atm-rotate'),10)||5)*1000;
    setInterval(function(){items[i].classList.remove('is-on');i=(i+1)%items.length;items[i].classList.add('is-on')},ms);
  });
  qa('[data-atm-track]').forEach(function(tr){
    if(tr.atmOn){return}tr.atmOn=true;
    var tick=null;
    tr.addEventListener('scroll',function(){if(tick){return}tick=setTimeout(function(){tick=null;syncThumbs(tr)},120)},{passive:true});
    syncThumbs(tr);
  });
  qa('[data-atm-vid]').forEach(function(fr){
    if(fr.atmOn){return}
    var v=q('video',fr);if(!v){return}
    fr.atmOn=true;
    v.loop=fr.getAttribute('data-loop')==='true';
    if(fr.getAttribute('data-atm-vid')!=='auto'){return}
    v.muted=true;v.setAttribute('muted','');v.setAttribute('playsinline','');
    if(fr.getAttribute('data-controls')==='true'){v.controls=true}
    var calm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(calm||!('IntersectionObserver' in window)){v.controls=true;v.preload='metadata';return}
    new IntersectionObserver(function(en){en.forEach(function(x){
      if(x.isIntersecting){var pr=v.play();if(pr&&pr.catch){pr.catch(function(){v.controls=true})}}else{v.pause()}
    })},{threshold:.35}).observe(fr);
  });
  qa('[data-atm-pd]').forEach(function(sec){
    if(sec.atmOn){return}sec.atmOn=true;
    var bar=q('[data-atm-sticky]',sec);var main=q('[data-atm-buy-main]',sec);
    if(bar&&main&&('IntersectionObserver' in window)){
      new IntersectionObserver(function(en){en.forEach(function(x){bar.classList.toggle('is-on',!x.isIntersecting)})}).observe(main);
    }
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
document.addEventListener('shopify:section:load',init);
window.Atmiva={openCart:openDrawer,closeCart:closeDrawer,refreshCart:refresh,openMenu:openNav,closeMenu:closeNav};
})();
